import React, { createContext, useContext, useEffect, useState } from 'react';
import { AccountWithOutageInfo } from '../types';
import { useAccountDetailsList } from '../hooks/useAccountDetailsList';

interface OutageAccountListContextProps {
  accountListWithOutageInfo: AccountWithOutageInfo[] | undefined;
  setAccountListWithOutageInfo: React.Dispatch<
    React.SetStateAction<AccountWithOutageInfo[] | undefined>
  >;
}

export const OutageAccountListContext = createContext<
  OutageAccountListContextProps | undefined
>(undefined);

export const OutageAccountListProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [accountListWithOutageInfo, setAccountListWithOutageInfo] = useState<
    AccountWithOutageInfo[] | undefined
  >(undefined);

  return (
    <OutageAccountListContext.Provider
      value={{
        accountListWithOutageInfo,
        setAccountListWithOutageInfo,
      }}
    >
      {children}
    </OutageAccountListContext.Provider>
  );
};

export const useOutageAccountListContext = (): OutageAccountListContextProps => {
  const ctx = useContext(OutageAccountListContext);
  if (!ctx) {
    throw new Error(
      'useOutageAccountList must be used within OutageAccountListProvider',
    );
  }
  return ctx;
};
